import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.75 4.75h5.75a3.75 3.75 0 1 1 0 7.5H6.75zM6.75 12.25h7a3.5 3.5 0 1 1 0 7h-7z"
    />
  </svg>
);
export default SvgBold;
